module.exports = __webpack_public_path__ + "12070e1e17240c9a2eebed0d511efe7c.pdf";